import { ViewModel,View, ObservableArray } from "binder"
import  { LogisticCostCartableView } from "./logisticCostCartable-view"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "src/uicomponents/components/extable/serverFilteringTable";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo } from "src/uicomponents/components/paginator/paginator-viewModel";
import moment from "moment";
import { LogisticCostInvoiceDetailViewModel } from "../logisticCostInvoiceDetail/logisticCostInvoiceDetail-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";

export class LogisticCostCartableViewModel extends WindowViewModel{
    public getTitle(): string {
        return "کارتابل ثبت هزینه های عملیاتی";
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.invoicesLists = ObservableArray.create<SingleInvoice>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),100);
        this.refresh();
        this.getRate();
    }
    GetDefaultView(): View <ViewModel> {
        return new LogisticCostCartableView();
    }
    public getTypeId(): string {
        return "VM-45AAD3D6-B845-4F63-A7DC-3E410017806B"
    }

    public set invoicesLists(v: ObservableArray<SingleInvoice>) { this._invoicesLists = v; } public get invoicesLists(): ObservableArray<SingleInvoice> { return this._invoicesLists;} private _invoicesLists: ObservableArray<SingleInvoice>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set rate(v: string) { this._rate = v; } public get rate(): string { return this._rate;} private _rate: string;

    refresh(){
        this.loader.refresh();
    }

    protected updateFilteringInformation(filteringInformation: any){
        if(filteringInformation.OrderInfo.length == 0)
        {
            let sort = {
                fieldName:'createdTime',
                order:'DESC',
                type:'date'
            };
            filteringInformation.OrderInfo = [sort];
        }
        return filteringInformation;
    }

    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/SellServices/GetAllReturnAndCancelAndNotDeliveredInvoices',{
                FilteringInformation:this.updateFilteringInformation(filteringInformation)
            });
            this.invoicesLists.update(...result.Invoices.map((q,i)=>{
                let r = new SingleInvoice(this);
                r.id = q.Id;
                r.rowNumber = i+1;
                r.customerName = q.CustomerName;
                r.sellerName = q.SellerName;
                r.creationTime = moment.utc(q.CreationTime);
                r.deliveryTime = q.DeliveryTime == null ? null : moment.utc(q.DeliveryTime);
                r.invoiceNumber = q.InvoiceNumber;
                r.parentInvoiceNumber = q.ParentInvoiceNumber;
                r.districtName = q.DistrictName;
                r.totalPrice = q.TotalPrice;
                r.finalPrice = q.FinalPrice;
                r.totalDeficit = q.TotalDeficits;
                r.invoiceType = q.InvoiceType;
                r.invoiceTypeName = q.InvoiceType == 2 ? "مرجوعی" : q.State == 3 ? "لغو شده" : "72 ساعت";
                r.warehouseState = q.WarehouseState;
                r.fromDistrict = q.IsFromRootDistrict == true ? 'اتوپارت' : 'شعب';
                r.state = q.State;
                r.logisticCostPlusWarehouseCost = q.WarehouseKeepingCost + q.LogisticCost;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }

    async showDetail (id:string) {
        let invoiceDetail = new LogisticCostInvoiceDetailViewModel(this);
        invoiceDetail.loadById(id);
        let result = await this.showPopup(invoiceDetail);
        if(result = true){
            this.refresh();
        }
    }

    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.rate)){
            result.push(' نرخ مشخص نشده است.')
        }
        return result;
    }

    async getRate() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/SellServices/GetWarehouseKeepingRate',{
            });
            if(result.IsSuccessful==false){
                throw "new Error";
            }
            this.rate = result.Rate;
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    async setRate() {
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان بروزرسانی نرخ');
                return;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/SellServices/SetWarehouseKeepingRate',{
                Rate:this.rate,
            });
            if(result.IsSuccessful==false){
                throw "new Error";
            }
            await this.messageBoxConfirmSuccess('بروزرسانی نرخ با موفقیت انجام شد.','عملیات موفق');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }
}

export class SingleInvoice extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:LogisticCostCartableViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set customerName(v: string) { this._customerName = v; } public get customerName(): string { return this._customerName;} private _customerName: string;
    public set sellerName(v: string) { this._sellerName = v; } public get sellerName(): string { return this._sellerName;} private _sellerName: string;
    public set invoiceNumber(v: number) { this._invoiceNumber = v; } public get invoiceNumber(): number { return this._invoiceNumber;} private _invoiceNumber: number;
    public set parentInvoiceNumber(v: string) { this._parentInvoiceNumber = v; } public get parentInvoiceNumber(): string { return this._parentInvoiceNumber;} private _parentInvoiceNumber: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;
    public set totalPrice(v: number) { this._totalPrice = v; } public get totalPrice(): number { return this._totalPrice;} private _totalPrice: number;
    public set finalPrice(v: number) { this._finalPrice = v; } public get finalPrice(): number { return this._finalPrice;} private _finalPrice: number;
    public set totalDeficit(v: number) { this._totalDeficit = v; } public get totalDeficit(): number { return this._totalDeficit;} private _totalDeficit: number;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime;} private _creationTime: moment.Moment;
    public set deliveryTime(v: moment.Moment) { this._deliveryTime = v; } public get deliveryTime(): moment.Moment { return this._deliveryTime;} private _deliveryTime: moment.Moment;
    public set invoiceType(v: number) { this._invoiceType = v; } public get invoiceType(): number { return this._invoiceType;} private _invoiceType: number;
    public set invoiceTypeName(v: string) { this._invoiceTypeName = v; } public get invoiceTypeName(): string { return this._invoiceTypeName;} private _invoiceTypeName: string;
    public set state(v: number) { this._state = v; } public get state(): number { return this._state;} private _state: number;
    public set warehouseState(v: number) { this._warehouseState = v; } public get warehouseState(): number { return this._warehouseState;} private _warehouseState: number;
    public set isFromRootDistrict(v: boolean) { this._isFromRootDistrict = v; } public get isFromRootDistrict(): boolean { return this._isFromRootDistrict;} private _isFromRootDistrict: boolean;
    public set fromDistrict(v: string) { this._fromDistrict = v; } public get fromDistrict(): string { return this._fromDistrict;} private _fromDistrict: string;
    public set logisticCostPlusWarehouseCost(v: number) { this._logisticCostPlusWarehouseCost = v; } public get logisticCostPlusWarehouseCost(): number { return this._logisticCostPlusWarehouseCost;} private _logisticCostPlusWarehouseCost: number;
    
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    
    private _typedParent:LogisticCostCartableViewModel;

    async edit() {
        this._typedParent.showDetail(this.id);        
    }
}
